import { render, staticRenderFns } from "./table-proposal-plenary-phase.vue?vue&type=template&id=54619ac5&scoped=true&"
import script from "./table-proposal-plenary-phase.vue?vue&type=script&lang=js&"
export * from "./table-proposal-plenary-phase.vue?vue&type=script&lang=js&"
import style0 from "./table-proposal-plenary-phase.vue?vue&type=style&index=0&id=54619ac5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54619ac5",
  null
  
)

export default component.exports